export const CreateItemMethodName: string              = "T42.Outlook.CreateItem";
export const ShowItemMethodName: string                = "T42.Outlook.ShowItem";
export const SaveItemMethodName: string                = "T42.Outlook.SaveItem";
export const OnSendMethodName: string                  = "T42.Outlook.OnSendMethod";
export const OnCancelMethodName: string                = "T42.Outlook.OnCancelMethod";
export const OnEmailReceivedMethodName: string         = "T42.Outlook.OnEmailReceived";
export const OnTaskCreatedMethodName: string           = "T42.Outlook.OnTaskCreated";
export const OutlookGetAttachmentMethodName: string    = "T42.Outlook.GetAttachment";
export const CreateLocalEmailMethodName: string        = "T42.Outlook.CreateLocalEmail";
export const OutlookGetItemAsMsgMethodName: string     = "T42.Outlook.GetItemAsMsgMethod";
export const TmpFilesAppendMethodName: string          = "T42.TmpFiles.Append";
export const OnTrackEmailMethodName: string            = "T42.CRM.TrackEmail";
export const OnUntrackEmailMethodName: string          = "T42.CRM.UntrackEmail";
export const OnTrackItemMethodName: string             = "T42.CRM.TrackCalendarItem";
export const OnUntrackItemMethodName: string           = "T42.CRM.UntrackCalendarItem";
export const CRMGetAttachmentMethodName: string        = "T42.CRM.GetAttachment";
export const CRMGetItemAsMsgMethodName: string         = "T42.CRM.GetItemAsMsg";
export const SyncTrackEmailMethodName: string          = "T42.CRM.SyncTrackEmail";
export const SyncUntrackEmailMethodName: string        = "T42.CRM.SyncUntrackEmail";
export const SyncTrackCalendarItemMethodName: string   = "T42.CRM.SyncTrackCalendarItem";
export const SyncUntrackCalendarItemMethodName: string = "T42.CRM.SyncUntrackCalendarItem";
export const SecureReplyMethodName: string             = "T42.CRM.SecureReply";
export const DisplaySecureMailMethodName: string       = "T42.CRM.DisplaySecureMail";
